import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const LoginPage = () => import("../pages/Authentication/LoginPage.vue");
const SetupWizardPage = () => import("../pages/Setup/SetupWizardPage.vue");
const DashboardPage = () => import("../pages/Dashboard/DashboardPage.vue");
const CustomersPage = () => import("../pages/Customers/CustomersPage.vue");
const CreateCustomerPage = () => import("../pages/Customers/CreateCustomerPage.vue");
const EditCustomerPage = () => import("../pages/Customers/EditCustomerPage.vue");
const ShowCustomerPage = () => import("../pages/Customers/ShowCustomerPage.vue");
const PackagesPage = () => import("../pages/Packages/PackagesPage.vue");
const CreatePackagePage = () => import("../pages/Packages/CreatePackagePage.vue");
const EditPackagePage = () => import("../pages/Packages/EditPackagePage.vue");
const InvoicesPage = () => import("../pages/Invoices/InvoicesPage.vue");
const CreateInvoicePage = () => import("../pages/Invoices/CreateInvoicePage.vue");
const EditInvoicePage = () => import("../pages/Invoices/EditInvoicePage.vue");
const ShowInvoicePage = () => import("../pages/Invoices/ShowInvoicePage.vue");
const PaymentsPage = () => import("../pages/Payments/PaymentsPage.vue");
const CreatePaymentPage = () => import("../pages/Payments/CreatePaymentPage.vue");
const VouchersPage = () => import("../pages/Hotspot/VouchersPage.vue");
const HotspotGroupsPage = () => import("../pages/Hotspot/HotspotGroupsPage.vue");
const VoucherTemplatePage = () => import("../pages/Hotspot/VoucherTemplatePage.vue");
const CreateVoucherTemplatePage = () => import("../pages/Hotspot/CreateVoucherTemplatePage.vue");
const EditVoucherTemplatePage = () => import("../pages/Hotspot/EditVoucherTemplatePage.vue");
const RoutersPage = () => import("../pages/Routers/RoutersPage.vue");
const EditRouterPage = () => import("../pages/Routers/EditRouterPage.vue");
const ResellersPage = () => import("../pages/Resellers/ResellersPage.vue");
const EditResellerPage = () => import("../pages/Resellers/EditResellerPage.vue");
const ResellerMembersPage = () => import("../pages/Resellers/ResellerMembersPage.vue");
const ShowResellerPage = () => import("../pages/Resellers/ShowResellerPage.vue");
const FtthPage = () => import("../pages/Ftth/FtthPage.vue");
const OltPage = () => import("../pages/Olt/OltPage.vue");
const OltDevicesPage = () => import("../pages/Olt/OltDevicesPage.vue");
const OltDeviceDetailPage = () => import("../pages/Olt/OltDeviceDetailPage.vue");
const OltOnuPage = () => import("../pages/Olt/OltOnuPage.vue");
const OltOnuDetailPage = () => import("../pages/Olt/OltOnuDetailPage.vue");
const OltAutoFindPage = () => import("../pages/Olt/OltAutoFindPage.vue");
const OltAlarmsPage = () => import("../pages/Olt/OltAlarmsPage.vue");
const InventoryPage = () => import("../pages/Inventory/InventoryPage.vue");
const InventoryItemsPage = () => import("../pages/Inventory/InventoryItemsPage.vue");
const InventoryRestockPage = () => import("../pages/Inventory/InventoryRestockPage.vue");
const InventoryPickupPage = () => import("../pages/Inventory/InventoryPickupPage.vue");
const InventoryHistoryPage = () => import("../pages/Inventory/InventoryHistoryPage.vue");
const AccountingProfitLossPage = () => import("../pages/Accounting/AccountingProfitLossPage.vue");
const AccountingCashflowPage = () => import("../pages/Accounting/AccountingCashflowPage.vue");
const AccountingBalanceSheetPage = () => import("../pages/Accounting/AccountingBalanceSheetPage.vue");
const AccountingJournalPage = () => import("../pages/Accounting/AccountingJournalPage.vue");
const AccountingLedgerPage = () => import("../pages/Accounting/AccountingLedgerPage.vue");
const AccountingAccountsPage = () => import("../pages/Accounting/AccountingAccountsPage.vue");
const AccountingGuidePage = () => import("../pages/Accounting/AccountingGuidePage.vue");
const FinanceCollectionPage = () => import("../pages/Finance/FinanceCollectionPage.vue");
const HrdPage = () => import("../pages/Hrd/HrdPage.vue");
const KaryawanPage = () => import("../pages/Hrd/KaryawanPage.vue");
const DepartmentPage = () => import("../pages/Hrd/DepartmentPage.vue");
const PositionPage = () => import("../pages/Hrd/PositionPage.vue");
const AbsensiPage = () => import("../pages/Hrd/AbsensiPage.vue");
const TugasPage = () => import("../pages/Hrd/TugasPage.vue");
const TrackingTeknisiPage = () => import("../pages/Hrd/TrackingTeknisiPage.vue");
const KomisiPage = () => import("../pages/Hrd/KomisiPage.vue");
const GajiPage = () => import("../pages/Hrd/GajiPage.vue");
const CutiPage = () => import("../pages/Hrd/CutiPage.vue");
const TelegramSettingsPage = () => import("../pages/Hrd/TelegramSettingsPage.vue");
const SalesPage = () => import("../pages/Sales/SalesPage.vue");
const GroupsPage = () => import("../pages/Groups/GroupsPage.vue");
const TicketsPage = () => import("../pages/Tickets/TicketsPage.vue");
const WhatsAppInboxPage = () => import("../pages/WhatsApp/WhatsAppInboxPage.vue");
const RegionsPage = () => import("../pages/Regions/RegionsPage.vue");
const CreateRegionPage = () => import("../pages/Regions/CreateRegionPage.vue");
const LogsPage = () => import("../pages/Logs/LogsPage.vue");
const ReportsPage = () => import("../pages/Reports/ReportsPage.vue");
const SettingsPage = () => import("../pages/Settings/SettingsPage.vue");
const SystemUpdatePage = () => import("../pages/System/SystemUpdatePage.vue");
const OnlineUsersPage = () => import("../pages/Reports/OnlineUsersPage.vue");
const BhpUsoPage = () => import("../pages/Reports/BhpUsoPage.vue");
const CustomerReportPage = () => import("../pages/Reports/CustomerReportPage.vue");
const UsageReportPage = () => import("../pages/Reports/UsageReportPage.vue");
const HotspotProfilesPage = () => import("../pages/Hotspot/HotspotProfilesPage.vue");
const CreateHotspotProfilePage = () => import("../pages/Hotspot/CreateHotspotProfilePage.vue");
const EditHotspotProfilePage = () => import("../pages/Hotspot/EditHotspotProfilePage.vue");
const ResellerReportPage = () => import("../pages/Resellers/ResellerReportPage.vue");
const MitrasPage = () => import("../pages/Mitra/MitrasPage.vue");
const MitraLayout = () => import("../components/Layouts/MitraLayout.vue");
const MitraDashboardPage = () => import("../pages/MitraPortal/MitraDashboardPage.vue");
const MitraGenerateVoucherPage = () => import("../pages/MitraPortal/MitraGenerateVoucherPage.vue");
const MitraVouchersPage = () => import("../pages/MitraPortal/MitraVouchersPage.vue");
const MitraProfilePage = () => import("../pages/MitraPortal/MitraProfilePage.vue");
const MitraRecapPage = () => import("../pages/MitraPortal/MitraRecapPage.vue");
const MitraCustomersPage = () => import("../pages/MitraPortal/MitraCustomersPage.vue");
const MitraInvoicesPage = () => import("../pages/MitraPortal/MitraInvoicesPage.vue");
const MitraBhpUsoPage = () => import("../pages/MitraPortal/MitraBhpUsoPage.vue");
const MitraOutletsPage = () => import("../pages/MitraPortal/MitraOutletsPage.vue");
const MitraProfilesPage = () => import("../pages/MitraPortal/MitraProfilesPage.vue");
const ErrorPage = () => import("../pages/ErrorPage.vue");
const LicenseBlockedPage = () => import("../pages/License/LicenseBlockedPage.vue");
const InvoicePayPage = () => import("../pages/Portal/InvoicePayPage.vue");
const IsolirPage = () => import("../pages/Portal/IsolirPage.vue");


const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
    meta: { requiresAuth: false },
  },
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "DashboardPage",
    component: DashboardPage,
    meta: { requiresAuth: true },
  },
  // Customers
  {
    path: "/customers",
    name: "CustomersPage",
    component: CustomersPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/customers/create",
    name: "CreateCustomerPage",
    component: CreateCustomerPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/customers/:id/edit",
    name: "EditCustomerPage",
    component: EditCustomerPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/customers/:id",
    name: "ShowCustomerPage",
    component: ShowCustomerPage,
    meta: { requiresAuth: true },
  },
  // Packages
  {
    path: "/packages",
    name: "PackagesPage",
    component: PackagesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/packages/create",
    name: "CreatePackagePage",
    component: CreatePackagePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/packages/:id/edit",
    name: "EditPackagePage",
    component: EditPackagePage,
    meta: { requiresAuth: true },
  },
  // Invoices & Payment
  {
    path: "/invoices",
    name: "InvoicesPage",
    component: InvoicesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/invoices/create",
    name: "CreateInvoicePage",
    component: CreateInvoicePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/invoices/:id",
    name: "ShowInvoicePage",
    component: ShowInvoicePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/invoices/:id/edit",
    name: "EditInvoicePage",
    component: EditInvoicePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/payments",
    name: "PaymentsPage",
    component: PaymentsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/payments/create",
    name: "CreatePaymentPage",
    component: CreatePaymentPage,
    meta: { requiresAuth: true },
  },
  // Hotspot
  {
    path: "/hotspot",
    name: "HotspotPage",
    redirect: "/hotspot/vouchers",
    meta: { requiresAuth: true },
  },
  {
    path: "/hotspot/vouchers",
    name: "VouchersPage",
    component: VouchersPage,
    meta: { requiresAuth: true },
  },
  // Routers
  {
    path: "/routers",
    name: "RoutersPage",
    component: RoutersPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/routers/create",
    redirect: "/routers",
    meta: { requiresAuth: true },
  },
  {
    path: "/routers/:id/edit",
    name: "EditRouterPage",
    component: EditRouterPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/routers/:id",
    name: "ShowRouterPage",
    component: () => import("../pages/Routers/RouterDetailPage.vue"),
    meta: { requiresAuth: true },
  },
  // Resellers
  {
    path: "/resellers",
    name: "ResellersPage",
    alias: ["/resellers/create"],
    component: ResellersPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/resellers/:id/edit",
    name: "EditResellerPage",
    component: EditResellerPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/resellers/:id",
    name: "ShowResellerPage",
    component: ShowResellerPage,
    meta: { requiresAuth: true },
  },
  // Mitra (admin) — terpisah dari Reseller
  {
    path: "/mitras",
    name: "MitrasPage",
    component: MitrasPage,
    meta: { requiresAuth: true },
  },
  // Mitra Portal (login terpadu di /login — path lama dipertahankan sebagai redirect)
  {
    path: "/mitra/login",
    redirect: { path: "/login" },
  },
  {
    path: "/mitra",
    component: MitraLayout,
    meta: { mitraOnly: true },
    redirect: { name: "MitraDashboardPage" },
    children: [
      {
        path: "dashboard",
        name: "MitraDashboardPage",
        component: MitraDashboardPage,
        meta: { mitraOnly: true },
      },
      {
        path: "generate",
        name: "MitraGenerateVoucherPage",
        component: MitraGenerateVoucherPage,
        meta: { mitraOnly: true },
      },
      {
        path: "vouchers",
        name: "MitraVouchersPage",
        component: MitraVouchersPage,
        meta: { mitraOnly: true },
      },
      {
        path: "recap",
        name: "MitraRecapPage",
        component: MitraRecapPage,
        meta: { mitraOnly: true },
      },
      {
        path: "customers",
        name: "MitraCustomersPage",
        component: MitraCustomersPage,
        meta: { mitraOnly: true },
      },
      {
        path: "bhp-uso",
        name: "MitraBhpUsoPage",
        component: MitraBhpUsoPage,
        meta: { mitraOnly: true },
      },
      {
        path: "invoices",
        name: "MitraInvoicesPage",
        component: MitraInvoicesPage,
        meta: { mitraOnly: true },
      },
      {
        path: "outlets",
        name: "MitraOutletsPage",
        component: MitraOutletsPage,
        meta: { mitraOnly: true },
      },
      {
        path: "profiles",
        name: "MitraProfilesPage",
        component: MitraProfilesPage,
        meta: { mitraOnly: true },
      },
      {
        path: "profile",
        name: "MitraProfilePage",
        component: MitraProfilePage,
        meta: { mitraOnly: true },
      },
    ],
  },
  // Groups
  {
    path: "/groups",
    name: "GroupsPage",
    component: GroupsPage,
    meta: { requiresAuth: true },
  },
  // Tickets
  {
    path: "/tickets",
    name: "TicketsPage",
    component: TicketsPage,
    meta: { requiresAuth: true },
  },
  // WhatsApp Inbox
  {
    path: "/whatsapp/inbox",
    name: "WhatsAppInboxPage",
    component: WhatsAppInboxPage,
    meta: { requiresAuth: true },
  },
  // Regions
  {
    path: "/regions",
    name: "RegionsPage",
    component: RegionsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/regions/create",
    name: "CreateRegionPage",
    component: CreateRegionPage,
    meta: { requiresAuth: true },
  },
  // Inventory
  {
    path: "/inventory",
    name: "InventoryPage",
    component: InventoryPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/items",
    name: "InventoryItemsPage",
    component: InventoryItemsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/pickup",
    name: "InventoryPickupPage",
    component: InventoryPickupPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/history",
    name: "InventoryHistoryPage",
    component: InventoryHistoryPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/restock",
    name: "InventoryRestockPage",
    component: InventoryRestockPage,
    meta: { requiresAuth: true },
  },
  // Accounting
  {
    path: "/accounting/profit-loss",
    name: "AccountingProfitLossPage",
    component: AccountingProfitLossPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/cashflow",
    name: "AccountingCashflowPage",
    component: AccountingCashflowPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/balance-sheet",
    name: "AccountingBalanceSheetPage",
    component: AccountingBalanceSheetPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/journal",
    name: "AccountingJournalPage",
    component: AccountingJournalPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/ledger",
    name: "AccountingLedgerPage",
    component: AccountingLedgerPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/categories",
    name: "AccountingAccountsPage",
    component: AccountingAccountsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/guide",
    name: "AccountingGuidePage",
    component: AccountingGuidePage,
    meta: { requiresAuth: true },
  },
  // Finance
  {
    path: "/finance/collections",
    name: "FinanceCollectionPage",
    component: FinanceCollectionPage,
    meta: { requiresAuth: true },
  },
  // Reseller Members
  {
    path: "/reseller-members",
    name: "ResellerMembersPage",
    component: ResellerMembersPage,
    meta: { requiresAuth: true },
  },
  // Hotspot Groups & Template
  {
    path: "/hotspot/groups",
    name: "HotspotGroupsPage",
    component: HotspotGroupsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hotspot/templates",
    name: "VoucherTemplatePage",
    component: VoucherTemplatePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hotspot/templates/create",
    name: "CreateVoucherTemplatePage",
    component: CreateVoucherTemplatePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hotspot/templates/:id/edit",
    name: "EditVoucherTemplatePage",
    component: EditVoucherTemplatePage,
    meta: { requiresAuth: true },
  },
  // FTTH
  {
    path: "/ftth",
    name: "FtthPage",
    component: FtthPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/ftth/genie-acs",
    name: "FtthGenieAcsPage",
    component: FtthPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/ftth/genie-acs/devices",
    name: "FtthGenieAcsDevicesPage",
    component: FtthPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/ftth/devices",
    name: "FtthDevicesPage",
    component: FtthPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/ftth/maps",
    name: "FtthMapsPage",
    component: FtthPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/ftth/olt",
    name: "FtthOltPage",
    component: FtthPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/ftth/odc",
    name: "FtthOdcPage",
    component: FtthPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/ftth/odp",
    name: "FtthOdpPage",
    component: FtthPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/ftth/poles",
    name: "FtthPolesPage",
    component: FtthPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/ftth/onts",
    name: "FtthOntsPage",
    component: FtthPage,
    meta: { requiresAuth: true },
  },
  // OLT
  {
    path: "/olt",
    name: "OltPage",
    alias: ["/olt-manager", "/olt/create", "/olt-manager/devices/create"],
    component: OltPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/olt/devices",
    name: "OltDevicesPage",
    alias: ["/olt-manager/devices"],
    component: OltDevicesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/olt/devices/:id",
    name: "OltDeviceDetailPage",
    alias: ["/olt-manager/devices/:id"],
    component: OltDeviceDetailPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/olt/onu",
    name: "OltOnuPage",
    alias: ["/olt-manager/onus"],
    component: OltOnuPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/olt/onu/:id",
    name: "OltOnuDetailPage",
    alias: ["/olt-manager/onus/:id"],
    component: OltOnuDetailPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/olt/auto-find",
    name: "OltAutoFindPage",
    alias: ["/olt-manager/auto-find"],
    component: OltAutoFindPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/olt/alarms",
    name: "OltAlarmsPage",
    alias: ["/olt-manager/alarms"],
    component: OltAlarmsPage,
    meta: { requiresAuth: true },
  },
  // HRD / Management Office
  {
    path: "/hrd",
    name: "HrdPage",
    alias: ["/office"],
    component: HrdPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hrd/karyawan",
    name: "KaryawanPage",
    component: KaryawanPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hrd/departemen",
    name: "DepartmentPage",
    component: DepartmentPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hrd/jabatan",
    name: "PositionPage",
    component: PositionPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hrd/absensi",
    name: "AbsensiPage",
    component: AbsensiPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hrd/tugas",
    name: "TugasPage",
    component: TugasPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/sales",
    name: "SalesPage",
    component: SalesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hrd/tracking-teknisi",
    name: "TrackingTeknisiPage",
    component: TrackingTeknisiPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hrd/komisi",
    name: "KomisiPage",
    component: KomisiPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hrd/gaji",
    name: "GajiPage",
    component: GajiPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hrd/cuti",
    name: "CutiPage",
    component: CutiPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hrd/settings/telegram",
    name: "TelegramSettingsPage",
    component: TelegramSettingsPage,
    meta: { requiresAuth: true },
  },
  // Logs
  {
    path: "/logs",
    redirect: "/logs/system",
  },
  {
    path: "/logs/:tab",
    name: "LogsPage",
    component: LogsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/auth-log",
    name: "RadiusAuthLogPage",
    component: LogsPage,
    meta: { requiresAuth: true },
  },
  // Settings - Tab routing (/settings/:tab)
  {
    path: "/settings",
    redirect: "/settings/general",
  },
  {
    path: "/settings/:tab",
    name: "SettingsPage",
    component: SettingsPage,
    meta: { requiresAuth: true },
  },
  // System Update
  {
    path: "/system/update",
    name: "SystemUpdatePage",
    component: SystemUpdatePage,
    meta: { requiresAuth: true },
  },
  // Reports — base redirect to financial tab
  {  path: "/reports", redirect: "/reports/financial" },
  // Online Users monitoring
  {
    path: "/reports/online-users",
    name: "OnlineUsersPage",
    component: OnlineUsersPage,
    meta: { requiresAuth: true },
  },
  // BHP & USO report
  {
    path: "/reports/bhp-uso",
    name: "BhpUsoPage",
    component: BhpUsoPage,
    meta: { requiresAuth: true },
  },
  // Customer Report
  {
    path: "/reports/customers",
    name: "CustomerReportPage",
    component: CustomerReportPage,
    meta: { requiresAuth: true },
  },
  // Usage Report
  {
    path: "/reports/usage",
    name: "UsageReportPage",
    component: UsageReportPage,
    meta: { requiresAuth: true },
  },
  // Reports with tab routing (financial, etc) — catch-all LAST
  {
    path: "/reports/:tab",
    name: "ReportsTabPage",
    component: ReportsPage,
    meta: { requiresAuth: true },
  },
  // Hotspot Profiles
  {
    path: "/hotspot/profiles",
    name: "HotspotProfilesPage",
    component: HotspotProfilesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hotspot/profiles/create",
    name: "CreateHotspotProfilePage",
    component: CreateHotspotProfilePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hotspot/profiles/:id/edit",
    name: "EditHotspotProfilePage",
    component: EditHotspotProfilePage,
    meta: { requiresAuth: true },
  },
  // Reseller Report
  {
    path: "/resellers/report",
    name: "ResellerReportPage",
    component: ResellerReportPage,
    meta: { requiresAuth: true },
  },
  // Public invoice payment (no auth, token-based)
  {
    path: "/invoice/:token",
    name: "InvoicePayPage",
    component: InvoicePayPage,
    meta: { requiresAuth: false },
  },
  // Public isolir page (no auth, IP-based detection)
  {
    path: "/isolir/:code",
    name: "IsolirPage",
    component: IsolirPage,
    meta: { requiresAuth: false },
  },
  // 404
  {
    path: "/:pathMatch(.*)*",
    name: "ErrorPage",
    component: ErrorPage,
  },
  // Setup Wizard (requires auth, no setup_required meta so guard allows access)
  {
    path: "/setup",
    name: "SetupWizardPage",
    component: SetupWizardPage,
    meta: { requiresAuth: true, isSetup: true },
  },
  {
    path: "/license-blocked",
    name: "LicenseBlockedPage",
    component: LicenseBlockedPage,
    meta: { requiresAuth: false },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp ? Date.now() >= payload.exp * 1000 : false;
  } catch {
    return true;
  }
}

// Auth guard
router.beforeEach((to, _from, next) => {
  // ===== Mitra Portal Branch =====
  // Path /mitra/* (kecuali /mitras admin) menggunakan token sendiri (ns_mitra_token)
  const isMitraPath = typeof to.path === "string" && (to.path === "/mitra" || to.path.startsWith("/mitra/"));
  if (isMitraPath) {
    const mitraToken = localStorage.getItem("ns_mitra_token");

    // Protected mitra route
    if (to.meta.mitraOnly) {
      if (!mitraToken) {
        next({ path: "/login" });
        return;
      }
      if (isTokenExpired(mitraToken)) {
        localStorage.removeItem("ns_mitra_token");
        localStorage.removeItem("ns_mitra_user");
        next({ path: "/login", query: { reason: "expired" } });
        return;
      }
      next();
      return;
    }

    next();
    return;
  }

  // ===== Admin Branch =====
  const token = localStorage.getItem("ns_token");

  // No token — redirect to login for auth-required pages
  if (to.meta.requiresAuth && !token) {
    next({ name: "LoginPage" });
    return;
  }

  // Token ada tapi sudah expired — bersihkan dan redirect ke login
  if (token && to.meta.requiresAuth && isTokenExpired(token)) {
    localStorage.removeItem("ns_token");
    localStorage.removeItem("ns_user");
    next({ name: "LoginPage", query: { reason: "expired" } });
    return;
  }

  // Already logged in — redirect away from login page
  if (to.name === "LoginPage" && token) {
    // Check if setup is still needed
    const setupComplete = localStorage.getItem("ns_setup_complete");
    if (setupComplete === "false") {
      next({ name: "SetupWizardPage" });
    } else {
      next({ name: "DashboardPage" });
    }
    return;
  }

  // Logged in but setup not done — force setup page (except setup page itself)
  // Treat null (missing / cleared localStorage) same as "false" — backend is the truth
  if (token && to.meta.requiresAuth && !to.meta.isSetup) {
    const setupComplete = localStorage.getItem("ns_setup_complete");
    if (setupComplete !== "true") {
      next({ name: "SetupWizardPage" });
      return;
    }
  }

  next();
});

export default router;
